/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Admin_TitleInputs */

const da_privacy_admin_title = /** @type {(inputs: Privacy_Admin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administratorer hos AImforA`)
};

/** @type {(inputs: Privacy_Admin_TitleInputs) => LocalizedString} */
const en_privacy_admin_title = da_privacy_admin_title;

/**

* @param {Privacy_Admin_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_admin_title = /** @type {((inputs?: Privacy_Admin_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Admin_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_admin_title(inputs)
	return /** @type {LocalizedString} */ ("Administratorer hos AImforA")
});